<template>
  <div v-if="literatureList && literatureList.length > 0">
    <marqueeScroll
      :data="literatureList"
      :class-option="classOption"
      id="indexLiterature"
      style="
        margin: 0 auto;
        overflow: hidden;
        margin-top: 40px;
        white-space: nowrap;
      "
      ref="marqueeScroll"
      @ScrollEnd="resetList"
    >
      <div class="indexLiterature">
        <img
          v-for="item in literatureList"
          :key="item.id"
          :title="item.title"
          style="margin-right: 50px; width: 183px; height: 240px"
          :src="indexImgPath + item.imgUrl"
          @click="toLink"
        />
      </div>
    </marqueeScroll>
  </div>
</template>

<script>
import marqueeScroll from '@/components/marqueeScroll'

import { pathConfig } from '../assets/util/baseConfig'

export default {
  props: {
    literatureList: {
      type: Array
    }
  },
  data() {
    return {
      indexImgPath: pathConfig.indexImgPath,
      classOption: {
        limitMoveNum: 3, // 开始无缝滚动的数据量
        direction: 3, // 0向下 1向上 2向左 3向右
        waitTime: 0
      },
      literatureListInterval: -1,
      childNodesInterval: -1
    }
  },
  components: {
    marqueeScroll: marqueeScroll
  },
  methods: {
    resetList() {
      this.$refs.marqueeScroll.reset()
    },
    toLink() {
      // const { href } = this.$router.resolve({
      //   path: '/resources'
      // })

      // window.open(href, '_blank')

      this.$router.push({ path: '/resources' })
    }
  }
}
</script>

<style scoped>
.indexLiterature {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/globalReferences.vue